import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CloseToastModal } from "../redux/uiReducer";

import { TOAST_TYPE } from "../Helpers/Enums";

const TIMEOUT = 4000;

const ToastModel = () => {
  const dispatch = useDispatch();
  const toastMessage = useSelector((state) => state.ui.toastMessage);
  const toastType = useSelector((state) => state.ui.toastType);

  const toastColor =
    !toastType || toastType === TOAST_TYPE.Sucess ? "#009944" : "#cf000f";

  useEffect(() => {
    setTimeout(() => {
      dispatch(CloseToastModal());
    }, TIMEOUT);
    return () => {};
  }, [dispatch]);

  return (
    <div
      className="toast-message"
      style={{
        background: toastColor,
        borderColor: toastColor,
      }}
    >
      {toastMessage}
    </div>
  );
};

export default ToastModel;
